import { Show } from 'solid-js';

type TimePickerProps = {
  value?: string;
  handleChange: (value: string) => void;
  label?: string;
  name?: string;
  disabled?: boolean;
  class?: string;
  dataTestId?: string;
};

export const TimePicker = (props: TimePickerProps) => {
  return (
    <div class={`relative ${props.class ?? ''}`}>
      <input
        type="time"
        name={props.name}
        value={props.value ?? ''}
        disabled={props.disabled}
        data-testid={props.dataTestId}
        class={`w-full h-10 px-3 pt-1 text-sm border rounded-md outline-none transition-colors [&::-webkit-calendar-picker-indicator]:scale-150 [&::-webkit-calendar-picker-indicator]:[filter:invert(25%)_sepia(90%)_saturate(1000%)_hue-rotate(175deg)_brightness(90%)]
          ${props.disabled ? 'bg-gray-100 text-gray-400' : `bg-white border-gray-400 hover:border-armstrong-blue focus:border-armstrong-blue focus:ring-1 focus:ring-armstrong-blue ${props.value ? 'text-black' : 'text-gray-400 focus:text-black'}`}
        `}
        onInput={(e) => props.handleChange(e.currentTarget.value)}
      />
      <Show when={props.label}>
        <label class="text-shadow-thick absolute left-2 -top-2.5 px-1 text-sm font-medium text-armstrong-blue pointer-events-none">
          {props.label}
        </label>
      </Show>
    </div>
  );
};
